module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "page verify-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [(true) ? _c('div', {
    staticClass: "verifying-page"
  }, [_c('v-flex', {
    staticClass: "logo-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/logo.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "content-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "left-section",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "body-section"
  }, [_c('h4', [_vm._v("Thank you for signing up with YouSound!")]), _vm._v(" "), _c('p', [_vm._v("\n                We’ve built powerful tools that allow you to maximize your\n                reach and generate revenue from your music.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Before artists can upload any content, we verify each artist\n                to ensure that the tools we offer are used responsibly. Each\n                artist is verified by individuals that specialize in the genre\n                you list your music under.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Please complete the questionnaire, and allow 3 days for a\n                response.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider-section"
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "right-section",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('h4', [_vm._v("Tell us about your music")])]), _vm._v(" "), _c('div', {
    staticClass: "body-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "pb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "input-text-section",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "What is your main Genre?",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.verifying_request.main_genre),
      callback: function($$v) {
        _vm.$set(_vm.verifying_request, "main_genre", $$v)
      },
      expression: "verifying_request.main_genre"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.releases),
      expression: "verifying_request.releases"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "How many releases do you have?"
    },
    domProps: {
      "value": (_vm.verifying_request.releases)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "releases", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.soundcloud_url),
      expression: "verifying_request.soundcloud_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Soundcloud URL"
    },
    domProps: {
      "value": (_vm.verifying_request.soundcloud_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "soundcloud_url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.bandcamp_url),
      expression: "verifying_request.bandcamp_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Bandcamp URL"
    },
    domProps: {
      "value": (_vm.verifying_request.bandcamp_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "bandcamp_url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.website_url),
      expression: "verifying_request.website_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.verifying_request.website_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "website_url", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-area-section",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.description),
      expression: "verifying_request.description"
    }],
    staticClass: "verifying-description form-control non-resizable",
    attrs: {
      "placeholder": "What artists and/or labels have you previously worked with?"
    },
    domProps: {
      "value": (_vm.verifying_request.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "description", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "action-section",
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    staticClass: "submit-btn"
  }, [_vm._v("Submit Your Application")])], 1)], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "verified-page"
  }, [_c('v-flex', {
    staticClass: "logo-section",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/logo.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h4', {
    staticClass: "verified-title"
  }, [_vm._v("Your application has been received!")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('label', {
    staticClass: "verified-text"
  }, [_vm._v("You are currently registered as a listener.")]), _vm._v(" "), _c('label', {
    staticClass: "verified-text"
  }, [_vm._v("While your account is being verified, you can discover new music\n          and follow users.")]), _vm._v(" "), _c('label', {
    staticClass: "verified-text"
  }, [_vm._v("If your account is approved, your activity will be transfered to\n          your Artist account.")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "awesome-btn"
  }, [_vm._v("Awesome, show me the music!")])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73e7913a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/get_verified.vue
// module id = 1776
// module chunks = 180